import { useMemo } from 'react';
import { useTriggerSelector } from './useTriggerSelector';

export const useSelectedTriggers = () => {
  const trigger = useTriggerSelector();
  return useMemo(() => trigger.selectedTriggers, [trigger.selectedTriggers]);
};
